/*=========================================================================================
  File Name: module-licenseinfo-actions.js
  Description: LicenseInfo Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import MisaOrderAPI from '@/api/MisaOrderAPI.js';

export default {
	loadBank: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: MisaOrderAPI.getAPIUrl() + '/banks'
		});

		if (res.Success && res.Data) {
			context.commit('updatelstBank', res.Data);
		}

		// Trả kết quả
		return res;
	}
};
